// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"16470c4b","239":"33d7c175","453":"833f9e60","732":"d0a905e1"}[chunkId] + ".chunk.js";
};